import logo from './logo.svg';
import './App.css';
import AllRoutes from './Components/AllRoutes';

function App() {
  return (
    <div className="App">
<AllRoutes/>
    </div>
  );
}

export default App;
